import React, { createContext, ReactNode, useContext, useState } from "react";
import TokenExpiryWatcher from "@app/postBill/components/tokenExpiryWatcher";

export interface PostbillSessionContextType {
  expireTime: number | null;
  setExpireTime: (time: number | null) => void;
}

export const PostbillSessionContext = createContext<PostbillSessionContextType>(
  {
    expireTime: null,
    setExpireTime: () => {},
  }
);

interface PostbillSessionProviderProps {
  children: ReactNode;
}

export const PostbillSessionProvider: React.FC<
  PostbillSessionProviderProps
> = ({ children }) => {
  const [expireTime, setExpireTime] = useState<number | null>(null);

  return (
    <PostbillSessionContext.Provider value={{ expireTime, setExpireTime }}>
      <TokenExpiryWatcher expireTime={expireTime}>
        {children}
      </TokenExpiryWatcher>
    </PostbillSessionContext.Provider>
  );
};

export const usePostbillSessionProvider = () => {
  const context = useContext(PostbillSessionContext);
  return context;
};

export default PostbillSessionProvider;
